import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@core/api/baseQuery';
import type { CompanyRef } from '@core/types/api';

export type IntegrationStatus = 'active' | 'suspended' | 'revoked';
export type CredentialState = 'active' | 'expired' | 'revoked';

export interface IntegrationCredential {
  uuid: string;
  client_id: string;
  secret_hint: string;
  state: CredentialState;
  expires_at: string;
  revoked_at: string | null;
  last_used_at: string | null;
}

/** One software vendor this organization lets in, and how far (ADR-0029). */
export interface IntegrationConnection {
  uuid: string;
  integrator: { slug: string; name: string };
  integrator_active: boolean;
  status: IntegrationStatus;
  scopes: string[];
  all_companies: boolean;
  companies: CompanyRef[];
  credentials: IntegrationCredential[];
  created_at: string;
  revoked_at: string | null;
}

export const integrationsApi = createApi({
  reducerPath: 'integrationsApi',
  baseQuery,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    listIntegrationConnections: builder.query<IntegrationConnection[], void>({
      query: () => '/api/integrations/connections/',
    }),
  }),
});

export const { useListIntegrationConnectionsQuery } = integrationsApi;
